// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  gwId: __t.u64().primaryKey().name("gw_id"),
  guildA: __t.u64().name("guild_a"),
  guildB: __t.u64().name("guild_b"),
  declaredBy: __t.identity().name("declared_by"),
  state: __t.string(),
  declaredAt: __t.timestamp().name("declared_at"),
  endsAt: __t.timestamp().name("ends_at"),
});
